module.exports = __webpack_public_path__ + "img/Alternatives-Alternatives scoping.45447095.svg";